import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const StepUpPrompt = ({ classes, error, isSubmitting, authMethod, onCancel, onConfirm, onGoogleConfirm }) => {
    const [password, setPassword] = useState('');
    const isGoogleAuth = authMethod === 'google';

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (isGoogleAuth || !password || isSubmitting) {
            return;
        }
        const submittedPassword = password;
        setPassword('');
        await onConfirm(submittedPassword);
    };

    return (
        <form className={classes.stepUp} onSubmit={handleSubmit} aria-labelledby="workflow-step-up-heading">
            <Typography id="workflow-step-up-heading" variant="subtitle2">
                {isGoogleAuth ? 'Confirm recent Google authentication' : 'Confirm recent password authentication'}
            </Typography>
            <Typography variant="body2" className={classes.muted}>
                {isGoogleAuth
                    ? 'Starting a run requires a fresh Google sign-in. Google will ask you to reauthenticate before returning to PINN Hub.'
                    : 'Starting a run requires a fresh password check. Your password is sent only to the authentication endpoint.'}
            </Typography>
            {!isGoogleAuth && <TextField
                id="workflow-step-up-password"
                label="Password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                inputProps={{ maxLength: 256 }}
                disabled={isSubmitting}
                fullWidth
            />}
            {error && <Typography className={classes.error} role="alert">{error}</Typography>}
            <div className={classes.actions}>
                {isGoogleAuth
                    ? <Button type="button" variant="contained" color="secondary" onClick={onGoogleConfirm} disabled={isSubmitting}>
                        {isSubmitting ? <CircularProgress size={18} /> : 'Reauthenticate with Google'}
                    </Button>
                    : <Button type="submit" variant="contained" color="secondary" disabled={!password || isSubmitting}>
                        {isSubmitting ? <CircularProgress size={18} /> : 'Confirm and start run'}
                    </Button>}
                <Button type="button" variant="outlined" onClick={onCancel} disabled={isSubmitting}>
                    Cancel
                </Button>
            </div>
        </form>
    );
};

export { StepUpPrompt };
